import { createSelector, createPrefixSelector } from '../utils/selectorUtils';

const selectors = Object.freeze({
    DEPARTURE_SELECT: 'data-tc-depdate-select',
    DEPARTURE_ROW: 'data-tc-depdate-row',
    DEPARTURE_CONTAINER: 'data-tc-depdate-container'
});

// Track which selects we've already bound to avoid duplicates
const boundSelects = new WeakSet();

const handleDateSelection = (event) => {
    const select = event.target;
    const webCode = select.getAttribute(selectors.DEPARTURE_SELECT);
    console.log("webCode", webCode)
    if (!webCode) return;

    const container = select.closest(createSelector(selectors.DEPARTURE_CONTAINER));
    console.log("container", container)
    if (!container) return;

    const tourDateRowsQuery = createPrefixSelector(selectors.DEPARTURE_ROW, `${webCode}_`);
    const selectedValue = select.value;
    console.log("selectedValue", selectedValue)

    // Simple toggle visibility
    container.querySelectorAll(tourDateRowsQuery).forEach(row => {
        console.log("row", row)
        const rowId = row.getAttribute(selectors.DEPARTURE_ROW);
        row.classList.toggle('hidden', rowId !== `${webCode}_${selectedValue}`);
    });
};

const attachEventListeners = () => {
    const selects = document.querySelectorAll(createSelector(selectors.DEPARTURE_SELECT));
    selects.forEach(select => {
        if (!boundSelects.has(select)) {
            select.addEventListener('change', handleDateSelection);
            boundSelects.add(select);
        }
    });
};



const cleanup = () => {
    const selects = document.querySelectorAll(createSelector(selectors.DEPARTURE_SELECT));
    selects.forEach(select => {
        if (boundSelects.has(select)) {
            select.removeEventListener('change', handleDateSelection);
            boundSelects.delete(select);
        }
    });
    document.removeEventListener('dynamicContentLoaded', attachEventListeners);
};

document.addEventListener('dynamicContentLoaded', attachEventListeners);
attachEventListeners();

export { cleanup };